import React from 'react';
import WholeCode from './WholeCode';
import DishesCardDetails from './DishesCardDetails';
import Card from './Card';
const HomePage = () => {
    return (
        <>
            <WholeCode
                mainHeading="Food Recipe Online Industry"
                belowParagraph="What are you waiting for"
                btn="Get Started"
                cardHeading="Food Recipe"
                cardBelowHeading="Order Your Favourite"
                cardParagraph="Did you know, Collin Street Bakery has been baking the world’s best fruitcake since 1896? That’s right! Our world-famous DeLuxe® Fruitcake recipe has won our bakery global prestige and fame. We begin with our Business, Costa Rican pineapple, ripe cherries, and golden raisins."
                topHomepageclass="homePagepic"
            />

            <br />
            <div className="container-fluid">
                <div className="row row-margin-05">
                    {
                        DishesCardDetails.map((value, index) => {
                            return <Card
                                key={index}
                                movieImgSrc={value.movieImgSrc}
                                movieCardTitle={value.movieCardTitle}
                                movieCardParagraph={value.movieCardParagraph}
                                btn={value.btn}
                                WatchingLink={value.WatchingLink}
                            />
                        })
                    }
                </div>
            </div>
        </>
    )
}
export default HomePage;